import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
import notify from 'devextreme/ui/notify'
const baseUri = "WebApi.asmx/api/presentationGroupService";
const store = {};
const mutations = {
    SET_PRESENTATIONGROUP_LIST_SIMPLE(state, posts) {
        state.presentationGroupListSimple = posts;
        state.presentationGroupListSimpleIsLoading = false;
    },
    GET_PGR_STATUS_LIST(state, posts) {
        state.pgrStatusList = posts.data;
        state.pgrStatusListIsLoading = false;
        state.pgrStatusListChanged = false;
    },
    GET_DETAIL(state, posts) {
        state.presentationGroupDetail = posts.data;
        state.presentationGroupDetailIsLoading = false;
        state.presentationGroupDetailChanged = false;
    },
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.presentationGroupDetailChanged = false;
            state.pgrStatusListChanged = false;
            notify("The changes were saved successfully");
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    presentationGroupListSimpleIsLoading: false,
    presentationGroupListSimple: [],
    pgrStatusListIsLoading: false,
    pgrStatusListChanged: false,
    pgrStatusList: [],
    presentationGroupDetailIsLoading: false,
    presentationGroupDetailChanged: false,
    presentationGroupDetail: {},
};
const getters = {};
const actions = {
    getPresentationGroupListSimple({ commit }) {
        state.presentationGroupListIsLoading = true;
        axios
            .get(baseUri + '/GetListSimple')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_PRESENTATIONGROUP_LIST_SIMPLE', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getPresentationGroupDetail({ commit }, data) {
        state.presentationGroupDetailIsLoading = true;
        var formData = new FormData();
        formData.append("pgrId", data.pgrId);
        axios
            .post(baseUri + '/GetDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getPgrStatusList({ commit }, data) {
        state.getPgrStatusListIsLoading = true;
        var formData = new FormData();
        formData.append("pgrId", data.pgrId);
        axios
            .post(baseUri + '/GetPgrStatusList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_PGR_STATUS_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    savePresentationGroupDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.presentationGroupDetail));
        formData.append("pgrStatusList", JSON.stringify(state.pgrStatusList));
        axios
            .post(baseUri + '/Update', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}